import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import LoginPage from "./LoginPage";
import ToolPage from "./ToolPage";
import "./App.css";

function ProfileMenu() {
  const { user } = useAuth();
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  // Close on click outside / Esc
  React.useEffect(() => {
    const onDocClick = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDocClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  const avatarLabel =
    (user?.email?.[0]?.toUpperCase() || user?.phone?.slice(-2) || "U")
      .toString()
      .slice(0, 2);

  const handleSignOut = async () => {
    // Lazy import to avoid cyclic import if you prefer
    const { supabase } = await import("./supabaseClient");
    await supabase.auth.signOut();
    window.location.replace("/login");
  };

  return (
    <div className="profile-wrap" ref={ref}>
      <button
        className="avatar-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Open profile menu"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="avatar-initials">{avatarLabel}</span>
      </button>

      {open && (
        <div className="profile-pop">
          <div className="profile-head">
            <div className="avatar-mini">{avatarLabel}</div>
            <div className="profile-meta">
              <div className="meta-name">{user?.email || "Signed in"}</div>
              {user?.phone && <div className="meta-sub">{user.phone}</div>}
            </div>
          </div>

          <div className="profile-actions">
            <a
              className="profile-link"
              href="mailto:support@yourcompany.com?subject=Subscription%20Help"
            >
              Manage / change subscription
            </a>

            <button className="profile-logout" onClick={handleSignOut}>
              Logout
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

// App.js
function HeaderRight() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="profile-anim ready">
      <ProfileMenu />
    </div>
  );
}


function Protected({ children }) {
  const { user, loading, hasToolAccess } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!hasToolAccess) {
    return (
      <div className="page">
        <div className="card">
          <h1 className="title">Access required</h1>
          <p className="subtitle">Your account does not have access to this tool.</p>
        </div>
      </div>
    );
  }
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <header className="topbar">
          <div className="brand">Contract Hero</div>
          {/* Only show the profile menu if the user is signed in */}
          <HeaderRight />
        </header>


        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <Protected>
                <ToolPage />
              </Protected>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
